/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentCouponAppliedViewModel } from "../types/IndividualPaymentCouponAppliedViewModel.ts";

export const individualPaymentCouponAppliedViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  description: z.string().nullish(),
  percentageText: z.string().nullish(),
  creationJustification: z.string().nullish(),
  userNameCreator: z.string().nullish(),
}) as unknown as ToZod<IndividualPaymentCouponAppliedViewModel>;
